<template>
    <div>
        <h6 v-if="showTitle">
            Diverse Business Designations
            <b-button size="sm" variant="info" title="Add a Designation" @click="newDesignation" v-if="editMode"><i class="fa fa-plus-circle"></i> Designation</b-button>
        </h6>

        <template v-if="editMode">
            <div class="alert alert-info">Click the Add Designation button above to list details and attach copies of your company's small/minority business designations.</div>
        </template>

        <sub-designation-modal v-if="editMode" ref="subDesignationModal" :subcontractorId="subcontractorId" :enableOther="enableOther" />
        <sub-designation-create-modal v-if="editMode" ref="subDesignationCreateModal" :subcontractorId="subcontractorId" />

        <template v-if="designations.length == 0">
            -- No Designations Added --
        </template>
        <template v-else>
            <b-table bordered striped hover small responsive :items="designations" :fields="fields">
                <template v-slot:cell(sub_designation_id)="data">
                    <template v-if="editMode">
                        <button type="button" class="btn btn-sm btn-link" v-on:click="editDesignation(data.item)" title="Edit Designation"><i class="fa fa-edit"></i></button>
                        <button type="button" class="btn btn-sm btn-link text-danger" v-on:click="deleteDesignation(data.item)" title="Delete Designation"><i class="fa fa-trash"></i></button>
                    </template>
                </template>

                <template v-slot:cell(designation_name)="data">
                    <template v-if="data.item.designation_name">{{ data.item.designation_name }}</template>
                    <template v-if="data.item.other_designation_name">{{ data.item.other_designation_name }}</template>
                </template>

                <template v-slot:cell(files)="data">
                    <template v-for="file in data.unformatted">
                        <div class="mb-2">
                            <div>{{ file.file_name }}</div>
                            <span v-if="!file.download_only && !printMode">
                                <a :href="`/files/view/${file.file_id}`" target="_blank">View</a>&nbsp;|
                            </span>
                            <span v-if="!printMode">
                                <a :href="`/files/download/${file.file_id}`" target="_blank">Download</a>
                            </span>
                            <span v-if="!printMode && editMode">
                                |&nbsp;<a href="javascript:void(0)" @click="deleteFile(data.item.sub_designation_id, file.file_id)" class="text-danger">Delete</a>
                            </span>
                        </div>
                    </template>
                </template>
            </b-table>
        </template>
    </div>
</template>

<script>
    export default {
        props: {

            editMode: {
                type: Boolean,
                default: false,
            },

            subcontractorId: {
                type: Number,
                required: true,
            },

            printMode: {
                type: Boolean,
                required: false,
                default: false,
            },

            showTitle: {
                type: Boolean,
                default: true,
            },

            enableOther: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                designations: this.$store.state.subcontractor.designations,
            }
        },

        computed: {
            fields(){
                //Check for edit mode
                if(this.editMode)
                {
                    return [
                        {key: 'sub_designation_id', label: 'Actions'},
                        {key: 'state_code', label: 'State'},
                        {key: 'designation_name', label: 'Designation'},
                        {key: 'certifying_agency', label: 'Certifying Agency'},
                        {key: 'files', label: 'Cert/Award'}
                    ];
                }

                return [
                    {key: 'state_code', label: 'State'},
                    {key: 'designation_name', label: 'Designation'},
                    {key: 'certifying_agency', label: 'Certifying Agency'},
                    {key: 'files', label: 'Cert/Award'}
                ];
            }
        },

        methods: {
            deleteFile(id, file_id) {
                this.$http.post(`files/delete/${file_id}`)
                .then(response => {
                    this.$toastr.success('Cert/Award Letter Removed');
                    for (let i = 0; i < this.designations.length; i++)
                    {
                        if (this.designations[i].sub_designation_id == id)
                        {
                            this.designations[i].files = [];
                            this.$store.commit('setDesignations', this.designations);
                        }
                    }
                })
            },

            newDesignation(){
                //Activate the modal
                this.$refs.subDesignationCreateModal.showModal();
            },

            editDesignation(desig){
                //Set the bid
                this.$refs.subDesignationModal.setModel(desig);

                //Activate the modal
                this.$refs.subDesignationModal.showModal();
            },

            deleteDesignation(desig){
                //Check for confirm
                if(!confirm('Are you sure you want to delete this Designation?'))
                {
                    return;
                }

                //Send it
                this.$http
                    .post('/subcontractors/designation/delete/' + desig.sub_designation_id)
                    .then(response => {
                        //Alert
                        this.$toastr.success('Designation Deleted');

                        //Delete the bid
                        //this.updateDesignations(desig, true);
                        this.$store.commit('deleteDesignation', desig);
                    });
            },
        },

        mounted() {

        }
    }
</script>